import React, { useEffect } from 'react'
import styled from 'styled-components'

import { FormField, Button } from 'components'

const Container = styled.div`
    display: flex;
    flex-direction: column;
`

const ButtonContainer = styled.div`
    display: flex;
    justify-content: flex-end;
    align-self: flex-end;
    margin-top: 0.5rem;
`

const Error = styled.div`
    font-size: 0.8rem;
    color: var(--error-color);
`

const Success = styled.div`
    margin-top: 0.2rem;
    font-size: 0.8rem;
    color: var(--success-color);
`

const PasswordInput = props => {
    const {
        type,
        onSubmit,
        onCancel,
        userEmail,
        success,
        error
    } = props;
    const [oldPassword, setOld] = React.useState('')
    const [oldError, setOldError] = React.useState(null)
    const [newPassword, setNew] = React.useState('')
    const [newError, setNewError] = React.useState(null)
    const [confirmPassword, setConfirm] = React.useState('')
    const [confirmError, setConfirmError] = React.useState(null)

    const [email, setEmail] = React.useState('')
    const [emailError, setEmailError] = React.useState(null)

    const [selection, setSelection] = React.useState(null)

    useEffect(() => {
        setOldError(null)
        setNewError(null)
        setConfirmError(null)
        setEmailError(null)

        setOld('')
        setNew('')
        setConfirm('')
        setEmail('')
    }, [type]);

    const formStyle = {
        margin: '0.2rem 0 0 0', 
        labelWeight: 'normal'
    }

    const onKeyDownHandler = (event) => {
        if (event.keyCode === 13 ) {
            submitForm()
        }
    }

    const submitForm = ()  => {
        let errors = {
            old: false,
            new: false,
            confirm: false,
            email: false
        }
        // Old password
        if(!oldPassword || oldPassword.length === 0){
            errors['old'] = 'Please enter a password'
        } 

        // New password
        if (!newPassword || newPassword.length === 0){
            errors['new'] = 'Please enter a password'
        } else if(oldPassword === newPassword){
            errors['new'] = 'Please enter a different password'
        } 

        // Confirm password
        if(!confirmPassword || confirmPassword.length === 0){
            errors['confirm'] = 'Please re-enter your password'
        } else if (newPassword !== confirmPassword){
            errors['confirm'] = 'Password do not match'
        } 

        // Email
        const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if(!email){
            errors['email'] = 'Please enter your email'
        } else if (!re.test(email)){
            errors['email'] = 'Please enter a valid email'
        } else if (userEmail !== email){
            errors['email'] = "Email doesn't match account"
        }

        // Submit logic
        if(type === 'CREATE_PASSWORD'){
            !errors['new'] & !errors['confirm'] && onSubmit(newPassword, type)
        } else if (type === 'CHANGE_PASSWORD'){
            !errors['old'] & ! errors['new'] & !errors['confirm'] && onSubmit({old: oldPassword, new: newPassword}, type)
        } else if (type === 'RESET_PASSWORD') {
            !errors['email'] && onSubmit(email, type)
        }

        // Errors
        errors['old'] ? setOldError(errors['old']) : setOldError(null)
        errors['new'] ? setNewError(errors['new']) : setNewError(null)
        errors['confirm'] ? setConfirmError(errors['confirm']) : setConfirmError(null)
        errors['email'] ? setEmailError(errors['email']) : setEmailError(null)        
    }

    if(type === 'CREATE_PASSWORD'){
        return (
            <Container>
                <FormField type='PASSWORD' label='Password' value={newPassword} error={newError} selected={selection==='newPassword'}
                    onChange={(value) => setNew(value)} onKeyDown={onKeyDownHandler} style={formStyle}
                    onFocus={() => setSelection('newPassword')}
                    onBlur={() => setSelection(null)}/>
                <FormField type='PASSWORD' label='Confirm password' value={confirmPassword} error={confirmError} selected={selection==='confirmPassword'}
                    onChange={(value) => setConfirm(value)} onKeyDown={onKeyDownHandler} style={formStyle}
                    onFocus={() => setSelection('confirmPassword')}
                    onBlur={() => setSelection(null)}/>
                
                {/* Buttons */}
                <ButtonContainer>
                    <Button text='Cancel' styles={{backgroundColor:'var(--primary-color)', margin: '0 0.5rem', boxShadowColor: 'transparent'}} onSelect={onCancel}/>
                    <Button text='Save' styles={{backgroundColor: 'var(--focus-color)', margin: 0}} onSelect={submitForm}/>
                </ButtonContainer>
            </Container>
        )
    } else if (type === 'CHANGE_PASSWORD') {
        return (
            <Container>
                <FormField type='PASSWORD' label='Old password' value={oldPassword} error={oldError} selected={selection==='oldPassword'}
                    onChange={(value) => setOld(value)} onKeyDown={onKeyDownHandler} style={formStyle}
                    onFocus={() => setSelection('oldPassword')}
                    onBlur={() => setSelection(null)}/>
                <FormField type='PASSWORD' label='New password' value={newPassword} error={newError} selected={selection==='newPassword'}
                    onChange={(value) => setNew(value)} onKeyDown={onKeyDownHandler} style={formStyle}
                    onFocus={() => setSelection('newPassword')}
                    onBlur={() => setSelection(null)}/>
                <FormField type='PASSWORD' label='Confirm password' value={confirmPassword} error={confirmError} selected={selection==='confirmPassword'}
                    onChange={(value) => setConfirm(value)} onKeyDown={onKeyDownHandler} style={formStyle}
                    onFocus={() => setSelection('confirmPassword')}
                    onBlur={() => setSelection(null)}/>

                <div style={{display: 'flex', flexDirection: 'column', marginTop: '0.5rem'}}>
                    {success && <Success>{success}</Success>}
                    {error && <Error>{error}</Error>}
                </div>
                
                {/* Buttons */}
                <ButtonContainer>
                    <Button text='Cancel' styles={{backgroundColor:'var(--primary-color)', margin: '0 0.5rem', boxShadowColor: 'transparent'}} onSelect={onCancel}/>
                    <Button text='Save' styles={{backgroundColor: 'var(--focus-color)', margin: 0}} onSelect={submitForm}/>
                </ButtonContainer>
            </Container>
        )
    } else if (type === 'RESET_PASSWORD') {
        return (
            <Container>
                {/* Last name */}
                <FormField type='TEXT' label='Email' value={email} selected={selection==='email'} error={error || emailError} success={error || emailError ? null : success}
                    onChange={(value) => setEmail(value)} onKeyDown={onKeyDownHandler} style={formStyle}
                    onFocus={() => setSelection('email')}
                    onBlur={() => setSelection(null)}/>

                {/* Buttons */}
                <ButtonContainer>
                    <Button text='Cancel' styles={{backgroundColor:'var(--primary-color)', margin: '0 0.5rem', boxShadowColor: 'transparent'}} onSelect={onCancel}/>
                    <Button text='Save' styles={{backgroundColor: 'var(--focus-color)', margin: 0}} onSelect={submitForm}/>
                </ButtonContainer>
            </Container>
        )
    } 
}

export default PasswordInput;